import useMasterplanPermissions from '../../hooks/useMasterplanPermissions';
import { setHolidaysForCalendar } from '../ganttContainer/gantt/helpers/calendarHolidays/holidayCalendarHelpers';
/**
 * Calendar helper functions for Gantt schedule
 */

/**
 * This function is executed when API has finished providing data,
 * to load calendars to gantt API and correct dates based on loaded calendars
 * @param {Object} gantt - The gantt instance
 * @param {Array} calendars - Array of calendars
 * @param {Object} config - Configuration options
 * @param {Object} config.tableConfig - Table configuration
 * @param {boolean} config.baselineSaveInProcess - Whether baseline save is in process
 * @param {Function} config.masterplanPermissions - Function to get masterplan permissions
 * @param {Function} config.setHolidaysForCalendar - Function to set holidays for calendar
 */
export const loadDataForCalendar = async (gantt, calendars) => {
  let hasDefaultCalendar = false;

  const calendarSelectorOptions = [];
  const calendarForFilters = [];
  gantt.getCalendars().map((calendar) => {
    gantt.deleteCalendar(calendar.id);
  });
  calendars.map((calendar) => {
    const workingDays = calendar.working_days.split(',').map((el) => eval(el));
    const shiftsArray = [];
    /** N workingdays integration */
    calendar.shifts
      .sort((a, b) => parseInt(a.correlative_id - parseInt(b.correlative_id)))
      .map((shift) => {
        shiftsArray.push(transformShiftToArray(shift.shift_string));
      });

    /** Load general Gantt worktime (default calendar) */
    const workTime = getWorkingDaysFromCalendar(workingDays);

    /** This code section set the default behaviour for TASK without calendar_id */
    if (calendar.is_default && typeof calendar.id !== 'string') {
      hasDefaultCalendar = true;
      gantt.defaultCalendar = calendar.id;
    }

    /** This code section set the default behaviour for TASK without calendar_id */
    if (calendar.baseDefault) {
      gantt.defaultBaseCalendar = calendar.id;
    }

    const singleShiftPerDay = workTime.map((singleWorktime, index) => {
      if (singleWorktime) {
        const toReturnArray = [];
        shiftsArray.map((nShift) => {
          if (nShift[index] !== 'false-false') {
            toReturnArray.push(nShift[index]);
          }
        });
        return toReturnArray;
      }
      return 0;
    });

    /** This code adds the calendar to DHTMLX API */
    const calendarToAdd = {
      id: calendar.id,
      worktime: {
        days: singleShiftPerDay
      }
    };
    if (typeof calendar.id !== 'string') {
      calendarSelectorOptions.push({
        key: calendarToAdd.id,
        label: calendar.name
      });
      calendarForFilters.push({
        value: calendarToAdd.id,
        label: calendar.name
      });
    }
    gantt.addCalendar(calendarToAdd);
    const calendarDhtmlxObject = gantt.getCalendar(calendarToAdd.id);

    /** Load all holidays from calendar */
    const holidays = calendar.exceptiondays;
    setHolidaysForCalendar(gantt, holidays, calendarDhtmlxObject);
    /** This function is KEY to keep performance in order (First render initial activities for user, then load calendars, and FINALLY) */
  });

  if (!hasDefaultCalendar) {
    gantt.defaultCalendar = 'global';
  }

  gantt.calendarOptions = calendarSelectorOptions;
  gantt.config.columns.find(
    (col) => col.name === 'calendar_id'
  ).editor.options = calendarSelectorOptions;

  // Execute correction of dates if needed

  gantt.correctWrongDates();

  if (useMasterplanPermissions()?.gantt.permission === 'V') {
    gantt.config.readonly = true;
  }
};

/**
 * This function handles legacy mixed nomenclature from v1 and transforms into a new version cal
 * @param {*} legacyWorkingTime Legacy array of numbers or boolean elements
 * @returns normalized array with working days calendar info
 */
export const getWorkingDaysFromCalendar = (legacyWorkingTime) => {
  const ganttDhtmlxWorktime = legacyWorkingTime.map((workingtime) => {
    switch (workingtime) {
      case true:
        return 1;
      case false:
        return 0;
      case 1:
        return 1;
      case 0:
        return 0;
      default:
        return 0;
    }
  });

  return ganttDhtmlxWorktime;
};

/**
 * This functions takes string DB pure shifts, and transforms it into an array
 * @param {*} shift String to be transformed into array of shifts
 * @returns Array with shifts and their worktime
 */
export const transformShiftToArray = (shift) => {
  const initArray = shift.split('-')[0].split(',');
  const endArray = shift.split('-')[1].split(',');
  const newArrayShift = [];

  initArray.map((el, index) => {
    const newShift = initArray[index] + '-' + endArray[index];
    newArrayShift.push(newShift);
  });

  return newArrayShift;
};
